import React,{useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useDispatch, useSelector } from 'react-redux';
import { bgColors } from '../utils/bgColor';
// import {setMapCentreCord} from "../../redux/actions/mapaction"
import { openCurrentFolioDialog,closeSurveySearchDialog } from '../../redux/actions/controlbuttonaction';
import {BootstrapDialog,BootstrapDialogTitle} from './Form/CustomDialog'
import ChevronLeftSharpIcon from '@mui/icons-material/ChevronLeftSharp';
import Select from 'react-select';
import {components } from 'react-select';
import {MdSearch} from 'react-icons/md'
import makeAnimated from 'react-select/animated';
import AddIcon from '@mui/icons-material/Add';
import { Divider, Grid, Typography } from '@mui/material';
import {openMenu,closeCurrentFolioDialog} from '../../redux/actions/controlbuttonaction'
import CurrentFolioDialog from './CurrentFolioDialog';
import { setFolio } from '../../redux/actions/currentfolioaction';
import { sidebarwith } from './Form/Const';

const animatedComponents = makeAnimated();

export default function Surveysearchdialogue(props) {
  const {open, handleClose} = props
  const dispatch = useDispatch()
  let openfoliodialog = useSelector(state => state.controlbutton.currentfoliodialog)
  let surveyno_json = useSelector(state => state.mapreducer.villagerevpoly.features)
   
  const surveyno = () => {
    if(surveyno_json!==undefined) 
    {const survey_mat = []
    surveyno_json.forEach((element,index) => {
        let _survey_no = {
            id:index,
            value: element.properties.survey_no,
            label: element.properties.survey_no,
            survey_no: element.properties.survey_no,
            state:  element.properties.state_name,
            district:  element.properties.district_name,
            subdistrict:  element.properties.subdistrict_name,
            village:  element.properties.village_name,
            centroid:{
                longitude:element.properties.centroid.coordinates[0],
                latitude:element.properties.centroid.coordinates[1]
            },
            coordinates: element.geometry.coordinates,
            surveyno_int: parseInt(element.properties.survey_no.replace(/[,."/\-=_//\\@*+?{}()" "]/g, ',').split(',')[0])
        }
        survey_mat.push(_survey_no)
        survey_mat?.sort((a, b) => (a.surveyno_int > b.surveyno_int ? 1 : -1))
        });
        return survey_mat
    }
   }
   const [options, setoptions]= useState([])
   useEffect(()=> {
    if(surveyno_json!==undefined)
        { setoptions(surveyno())}
    },[surveyno_json])
  const [selectedsurveys, setSelectedSurveys] = useState([])
  const [currentFolio, setCurrentFolio] = useState([])
  const handleChange = (e) => {
    setSelectedSurveys(Array.isArray(e) ? e.map(x => x.value) : []);
    setCurrentFolio(Array.isArray(e) ? e.map(x => x) : []);

  }


  const handlegoback = () => {
    dispatch(closeSurveySearchDialog)
    dispatch(openMenu)
    
  }
//   console.log(currentFolio)

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <MdSearch style = {{height:'25px', width:'25px'}}/>
        </components.DropdownIndicator>
        )
    );
    };
    const styles = {
        control: (base, state) => ({
            ...base,
            background: bgColors.default_backgroun_grey,
            // background: bgColors[gm2-grey-100],
            // gm2-grey-100
            // match with the menu
            borderRadius: state.isFocused ? bgColors.grey_700 : 10,
            // Overwrittes the different states of border
            borderColor: state.isFocused ? bgColors.grey_700 : bgColors.blue_500,
            // Removes weird border around container
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
              // Overwrittes the different states of border
              borderColor: state.isFocused ? bgColors.grey_700 : bgColors.blue_500,
              borderRadius: state.isFocused ? bgColors.grey_700 : 10,
            },
            "&:focussed": {
                // Overwrittes the different states of border
                borderColor: state.isFocused ? bgColors.grey_700 : bgColors.blue_500,
                borderRadius: state.isFocused ? bgColors.grey_400 : 10,
              }
          }),
        valueContainer: base => ({
          ...base,
          paddingLeft: 24,
        //   backgroundColor: bgColors.grey_900,
          color:bgColors.grey_500
        }),
        menuList: styles => ({
            ...styles,
            background: bgColors.default_backgroun_grey,
            color:bgColors.grey_800,
            borderRadius:5
           
        }),
        option: (styles, {isFocused, isSelected}) => ({
            ...styles,
            background: isFocused
                ? bgColors.blue_500
                : isSelected
                    ? bgColors.grey_400
                    : undefined,
            zIndex: 10
        }),
    
      };


  const handleAddtoFolio = () => {
    dispatch(setFolio(currentFolio))
    dispatch(openCurrentFolioDialog)
  }

  return (
    // <div  style = {{maxWidth:'300px'}}>
    <>
      <BootstrapDialog
        hideBackdrop
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        scroll="paper"
        sx={{
            "& .MuiDialog-container": {
               alignItems: "flex-start",
               "& .MuiPaper-root": {
                        minHeight:"400px",
                        width:sidebarwith,
                        marginLeft:'0.1rem'
                    },
            },
         }}
        
        PaperProps={{sx: {position:'fixed' , top:20, left:5} ,style:{borderRadius: 5,
        background:bgColors.default_backgroun_grey,
        color:bgColors.font_blue
        }}}
      >
        <BootstrapDialogTitle id="survey_search" onClose={handleClose}>
        <Typography  style={{color:bgColors.font_blue, 
          fontSize: 30, 
          fontFamily: 'roboto'}}>
          Search survey_no
          </Typography>
        
        </BootstrapDialogTitle>
        <DialogContent dividers>
        {surveyno_json!==undefined && 
        <Select id="survey_select"  
            isMulti
            closeMenuOnSelect={true}
            value={options.filter(obj => selectedsurveys.includes(obj.value))} 
            options = {options}
            components={{animatedComponents,DropdownIndicator, animatedComponents }}
            styles={styles}
            onChange={handleChange}
            />
        }
        </DialogContent>
        <DialogActions>
        <Grid container sx = {{display:'flex', direction:'column'}}>
        <Button key = {'open_menu_button'} size='small' sx={{marginRight:'0.5rem'}} 
        // onClick={()=> dispatch(openMenu)} 
        onClick={handlegoback} 
        >
        <ChevronLeftSharpIcon sx={{ mr: 1}} />
            go back
        </Button>
        <Grid>
        <Divider orientation='vertical' style = {{backgroundColor:bgColors.grey_300}}/>
        </Grid>
        <Button key = {'add_to_folio_button'} size='small' sx={{marginLeft:'0.5rem'}} 
            onClick={handleAddtoFolio}
            // onClick={()=>dispatch(openCurrentFolioDialog)}
            >
        <AddIcon sx={{ mr: 1}} />
         add to folio
        </Button>
        </Grid>
        </DialogActions>
      </BootstrapDialog>
      <CurrentFolioDialog
        open= {openfoliodialog}
        handleClose={() => {dispatch(closeCurrentFolioDialog)}}
      /> 
      </>
  );
}